import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoMoeda } from '../models/projeto-moeda.model';
import { ProdutoModalidade } from '../models/produto-modalidade.model';

@Injectable()
export class ProdutoModalidadeService extends BaseService<ProdutoModalidade> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/produto-modalidade';
  }
}
